export const mixin = {
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  created() {
    if (window && document) {
      this.handleScroll();
    }

    if (window) {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  },
  destroyed() {
    if (window) {
      window.removeEventListener('resize', this.handleResize);
    }
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    handleScroll() {
      window.addEventListener('scroll', () =>
        document.documentElement.style.setProperty(
          '--scroll-y',
          `${window.scrollY}px`
        )
      );
    },
    scrollHide() {
      if (document) {
        const scrollY =
          document.documentElement.style.getPropertyValue('--scroll-y');
        const body = document.body;
        body.classList.add('no-scroll');
        body.style.position = 'fixed';
        body.style.top = `-${scrollY}`;
      }
    },
    scrollShow() {
      if (document) {
        const body = document.body;
        const scrollY = body.style.top;
        body.classList.remove('no-scroll');
        body.style.position = '';
        body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    },
  },
};
